import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminService } from '../../services/adminService';
import './Admin.css';

const AdminWallets = () => {
  const [wallets, setWallets] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchWallets = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    params.set('page', page);
    adminService.getWallets(params.toString())
      .then(res => {
        setWallets(res.data.data);
        setLastPage(res.data.last_page);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchWallets(); }, [page]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchWallets();
  };

  return (
    <div className="admin-page">
      <h1>Wallets</h1>
      <div className="admin-table-wrapper">
        <div className="admin-toolbar">
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: '8px', flex: 1 }}>
            <input placeholder="Search by name or email..." value={search} onChange={e => setSearch(e.target.value)} />
            <button type="submit" className="admin-action-btn edit">Search</button>
          </form>
        </div>
        {loading ? <div style={{ padding: 20 }}>Loading...</div> : (
          <>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Email</th>
                  <th>Balance</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {wallets.map(w => (
                  <tr key={w.id}>
                    <td>{w.first_name} {w.last_name || ''}</td>
                    <td>{w.email}</td>
                    <td>🪙 {parseFloat(w.balance).toFixed(0)}</td>
                    <td>
                      <button className="admin-action-btn edit" onClick={() => navigate(`/admin/wallets/${w.user_id}`)}>View</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="admin-pagination">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)}>← Prev</button>
              <span style={{ padding: '6px 12px', fontSize: '0.85rem' }}>Page {page} of {lastPage}</span>
              <button disabled={page >= lastPage} onClick={() => setPage(page + 1)}>Next →</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminWallets;
